export enum EPriceRuleType {
  STAYED_AT_LEAST_X_DAYS = 'STAYED_AT_LEAST_X_DAYS',
  BOOKED_WITHIN_AT_MOST_X_DAYS = 'BOOKED_WITHIN_AT_MOST_X_DAYS',
  BOOKED_BEYOND_AT_LEAST_X_DAYS = 'BOOKED_BEYOND_AT_LEAST_X_DAYS',
  SEASONAL_ADJUSTMENT = 'SEASONAL_ADJUSTMENT',
}
